import PropTypes from 'prop-types';
import React from 'react';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const ClientsFilter = ({
    loading,
    filters,
    restoreFilterValues,
    options,
}) => {
    return (
        <Field
            component={Form.ReduxSelect}
            disabled={loading}
            loading={loading}
            multiple
            name='clients'
            options={options}
            placeholder='Client'
            search
            selection
            setValue={restoreFilterValues(filters, 'clients')}
        />
    );
};

ClientsFilter.propTypes = {
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
};
